import React from 'react'

import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { FollowEvent } from '@custom-types/activity'
import { buildAvatarUrl } from '@models/util/user.util'
import { formatRelativeTime } from '@utils/formatters/date.formatter'
import PageRoutes from '@utils/page-routes'

interface Props {
  event: FollowEvent
}

const FollowActivity: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation()
  const { action, actionTarget, actor } = event
  return (
    <div className="ml-3 flex-1 flex flex-row items-center">
      <span className="flex-1 flex flex-row items-center break-words">
        <ExternalLink
          className="underline-link mr-1 flex flex-row items-center"
          href={PageRoutes.userProfilePath(actor.external_id)}>
          {actor.username}
        </ExternalLink>
        {t(`event.${action}`)}
        <ExternalLink
          className="underline-link mr-1 flex flex-row items-center"
          href={PageRoutes.userProfilePath(actionTarget.external_id)}>
          <div className="w-[20px] h-[20px] inline-block mx-1">
            <img src={buildAvatarUrl(actionTarget)} alt={actionTarget.username} />
          </div>
          {actionTarget.username}
        </ExternalLink>
      </span>
      <span className="text-gray-text dark:text-gray-text-dm pl-2.5 text-xs whitespace-nowrap">
        {formatRelativeTime(event.when, new Date())}
      </span>
    </div>
  )
}

export default FollowActivity
